import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { UserIcon2 } from '../components/shared/Icons';
import { SupervisorProvider, SuperSlots, SuperResponses, SuperRoster, SuperMessages } from './SupervisorAvailability';
import { CreateCasualJobs } from './CreateCasualJobs';
import { JobsCountBadge, OpenSlotsBadge, ToApproveBadge, MessagesBellBadge } from './superTabBadges';

// InnerTabsm takes at most 3 tabs, so the mobile page splits across two
// outer tabs: Create Jobs (one inner) and Casual Jobs (three inner). One
// provider wraps both so the pipeline list is shared.
const TABS = [
  { id: 'createjobsm',        label: 'Create Jobs' },
  { id: 'workavailablesuperm', label: 'Casual Jobs' },
];

const CREATE_INNER = [
  { id: 'createjobsinnerm', label: 'Jobs',     icon: <UserIcon2 />, component: CreateCasualJobs, placeholder: JobsCountBadge },
  { id: 'messagesm',        label: 'Messages', icon: <UserIcon2 />, component: SuperMessages,    placeholder: MessagesBellBadge },
];
const SUPER_INNER = [
  { id: 'openslotsm', label: 'Slots',   icon: <UserIcon2 />, component: SuperSlots,     placeholder: OpenSlotsBadge },
  { id: 'responsesm', label: 'Replies', icon: <UserIcon2 />, component: SuperResponses, placeholder: ToApproveBadge },
  { id: 'rosterm',    label: 'Roster',  icon: <UserIcon2 />, component: SuperRoster },
];

const FilterAvailablesuperm = () => {
  const [activeTab, setActiveTab] = useState('createjobsm');
  const { homeAccent } = useUser();

  return (
    <div className="fr-tab-page">
      <TabBar tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} homeRoute="/profile" homeColor={homeAccent} />
      <div className="fr-tab-content">
        <SupervisorProvider>
          {activeTab === 'createjobsm' && <InnerTabsm tabs={CREATE_INNER} defaultId="createjobsinnerm" />}
          {activeTab === 'workavailablesuperm' && <InnerTabsm tabs={SUPER_INNER} defaultId="openslotsm" />}
        </SupervisorProvider>
      </div>
    </div>
  );
};

export default FilterAvailablesuperm;